import {NgModule} from '@angular/core';
import {SharedModule} from '../../core/shared.module';
import {UIRouterModule} from '@uirouter/angular';
import {CalculationListComponent} from './calculation-list.component';
import {CalculationTableComponent} from './calculation-table.component';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {CALCULATION_STATES} from './calculation.states';
import {CalculationCopyModalComponent} from './calculation-copy-modal.component';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {CalculationListFormComponent} from './calculation-list-form.component';
import {CalculationGoldListComponent} from './gold/calculation-gold-list';
import {CalculationGoldThreeMonthListComponent} from './gold/calculation-gold-three-month-list';
import {CalculationNavigationComponent} from './calculation-navigation/calculation-navigation.component';

@NgModule({
    imports: [
        UIRouterModule.forChild({ states: CALCULATION_STATES }),
        SharedModule,
        NgbTooltipModule,
        NgbModalModule,
    ],
    declarations: [
        CalculationListComponent,
        CalculationTableComponent,
        CalculationCopyModalComponent,
        CalculationListFormComponent,
        CalculationNavigationComponent,
        CalculationGoldListComponent,
        CalculationGoldThreeMonthListComponent,
    ],
    exports: [CalculationCopyModalComponent]
})
export class CalculationModule {
}
